module.exports = __webpack_public_path__ + "media/dagens-industri-91ef4c89.svg";